var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileXls = function SvgFileXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M7.8.6h8.67c1.103 0 2.162.434 2.948 1.208l7.729 7.609A4.2 4.2 0 0 1 28.4 12.41V27.2a4.2 4.2 0 0 1-4.2 4.2H7.8a4.2 4.2 0 0 1-4.2-4.2V4.8A4.2 4.2 0 0 1 7.8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M18 1v6.8a3.2 3.2 0 0 0 3.2 3.2H28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M0 17a3 3 0 0 1 3-3h17a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.878 17.682-2.094 3.106L8.975 24h-1.47L6.01 21.747 4.496 24H3.079l2.191-3.212-2.112-3.106H4.62l1.417 2.13 1.426-2.13zM9.763 24v-6.318h1.302v5.2h2.904V24zm4.536-1.153.888-.862c.467.66 1.144 1.02 1.84 1.02.66 0 1.144-.281 1.144-.818 0-.58-.599-.66-1.55-.871-.94-.22-1.962-.52-1.962-1.76 0-1.214 1.039-1.971 2.35-1.971 1.091 0 1.945.484 2.385 1.117l-.854.836c-.37-.519-.862-.862-1.566-.862-.616 0-1.039.29-1.039.748 0 .493.458.59 1.285.774 1.003.22 2.235.467 2.235 1.857 0 1.276-1.117 2.042-2.472 2.042-1.065 0-2.174-.484-2.684-1.25"
  })));
};
export default SvgFileXls;